// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__2pMYO","on":"style_on__2oEf3","rate":"style_rate__dAA2I"};